import { Icons } from '@innovamat/innova-components';
import { IconRecord, IconType } from '../types/icons';

export const getIcon = (icon: IconType) => Icons[icon];

export const getIconFromKey = (iconsList: IconRecord, key: string) => {
  const iconKey = iconsList[key as keyof typeof iconsList];
  return iconKey ? getIcon(iconKey) : undefined;
};
